import { Component, Input, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Observable } from 'rxjs';
import { LoggerService } from '@core/services/logger/logger.service';
import { AwarenessFacade } from '@modules/awareness/awareness.facade';

@Component({
	selector: 'rx-awareness-banner',
	templateUrl: './awareness-banner.component.html',
	styleUrls: ['./awareness-banner.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class AwarenessBannerComponent {
	private static componentName = 'AwarenessBannerComponent';

	@ViewChild('miniPopup')
	miniPopup: TemplateRef<unknown>;
	@Input() showBannerButton = true;
	@Input() qrName = '';
	@Input() flat = false;

	linkToTheLearningCenter$ = this.awarenessFacade.linkToTheLearningCenter$;
	showLearningCenterPart$ = this.awarenessFacade.showLearningCenterPart$;
	shouldNotifyCompanyByEmail$ = this.awarenessFacade.shouldNotifyCompanyByEmail$;

	constructor(private matDialog: MatDialog, private loggerService: LoggerService, private awarenessFacade: AwarenessFacade) {}

	openPopup(): Observable<unknown> {
		this.loggerService.info(`Awareness QR was opened from banner, when procedure flow is ${String(this.isProcedureFlow)}`, {
			module: AwarenessBannerComponent.componentName
		});

		return this.matDialog.open(this.miniPopup).afterClosed();
	}

	get isProcedureFlow(): boolean {
		return this.awarenessFacade.isProcedureFlow;
	}
}
